const APP_CONFIG = {
  FRONTEND_VERSION: 46,
  CLIENT_PLATFORM: "web",
};

export default APP_CONFIG;
